import { observable } from "mobx";
import { Type } from "class-transformer";
import VehicleResponse from "./vehicleResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SentEmailMessageChargeResponse {
  /**
   * Charge ID.
   */
  id!: string;

  /**
   * Price list item ID.
   */
  @observable
  priceListItemId!: string;

  @observable
  @Type(() => VehicleResponse)
  vehicle!: VehicleResponse;

  /**
   * Charge is valid since this date and time.
   */
  @observable
  @Type(() => Date)
  validSince!: Date;

  /**
   * Charge is valid until this date and time.
   */
  @observable
  @Type(() => Date)
  validUntil!: Date;
}
